import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './styles/App.css';
import { instance } from './common';
import TopTitle from './TopTitle';
import Bottom_menu from "./Bottom_menu";
import jsonp from 'jsonp';
import DaumPostcode from 'react-daum-postcode';
import serach_img from './img/bx_bx-search-alt.png';




const Postcode = ({inputs,setInputs,isPost,setIsPost}) => {
    

        
    const postCodeStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        border: "1px solid #000000",
        maxWidth: "700px",
        maxHeight: "500px"
    };

    const postClose = {
    borderBottom:'1px solid black',
    height:'30px',
    textAlign:'right',
    padding:'4px 7px',
    background:'#F3F3F3'
    }

    const closeImage = {
    fontSize:'19px',
    lineHeight:'19px'
    }



    const handleComplete = (data) => {
      let fullAddress = data.address;
      let extraAddress = ''; 
      
      if (data.addressType === 'R') {
        if (data.bname !== '') {
          extraAddress += data.bname;
        }
        if (data.buildingName !== '') {
          extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
        }
        fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
      }
  
      console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
      setInputs({
        ...inputs,
        si_address:fullAddress
      });

  
      setIsPost(!isPost);

      
      
    }
  
  
    const closePost = () => {
      setIsPost(!isPost);
    }
  
    return (
      <div style={postCodeStyle}>
        <div style={postClose}>
          <span style={closeImage} onClick={closePost}>X</span>
        </div>
        <DaumPostcode
          onComplete={handleComplete}
          autoClose
        />
      </div>
    );
  }
  


function Sigungu({si_area1,si_area2,onChange}){

    const [data, setData] = useState([]);

    useEffect(() => {
        
        const fetchData = async () => {

            jsonp('https://api.vworld.kr/req/data?key=8CB0729A-B502-352F-A0F6-CF78C521E905&domain=http://someguywork3.cafe24.com/&request=GetFeature&size=42&data=LT_C_ADSIGG_INFO&attrFilter=full_nm:like:'+si_area1, null, function (err, res) {
                if (err) {
                    console.error('err.message : ', err.message);
                } else {
                    if(res.response.status === 'OK'){
                        console.log('data.response.result.featureCollection.features : ', res.response.result.featureCollection.features)
                        setData(res.response.result.featureCollection.features)
                    }
                    
                    
                }
            });
    
        };
        
        fetchData();


    }, [si_area1]);


    return (
        <select name="si_area2" className="form-control col mr-2" onChange={onChange} value={si_area2}>
            {
                
                data.map((v,i) => 
                    i === 0 
                    ?
                    <>
                        <option value="">-</option>
                        <option value={v.properties.sig_kor_nm}>{v.properties.sig_kor_nm}</option>
                    </>
                    :
                    <option value={v.properties.sig_kor_nm}>{v.properties.sig_kor_nm}</option>
                )
            }
        </select>
    )
}


function S_storeSetting({history}) {

    const [data, setData] = useState([]);
    const [isPost ,setIsPost] = useState(false);
    const [isModi ,setIsModi] = useState(false);
    const [inputs, setInputs] = useState({
        si_as: '',
        si_area1: '',
        si_area2: '',
        si_name: '',
        si_tel: '',
        si_tel2: '',
        si_possible: '',
        si_img : '',
        si_rest: '',
        si_dongsi: '',
        si_address: '',
    });

    const [modifyObj, setModifyObj] = useState({
        u_company_num:'',
        u_company_name:'',

      });

    const { si_as, si_area1, si_area2, si_name, si_tel, si_tel2, si_possible, si_rest, si_dongsi, si_address} = inputs;
    const { u_company_name,u_company_num} = modifyObj;

    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;
    const u_id = parsedsigong.u_id;
   
    let obj = {
        si_id: si_id
    }
    console.log('ㅁㄴㅇ', parsedsigong);

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/sigong/id', obj).then(function (res) {
                // console.log('res : ', res)
                setData(res.data[0]);
                if (res.data[0]) {
                    setInputs(res.data[0]);
                }
            });

        };
        fetchData();
    }, []);

    const onChange = (e) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            [name]: value
        })
    }
    if(!isModi){
        modifyObj.u_company_name = parsedsigong.u_company_name;
        modifyObj.u_company_num = parsedsigong.u_company_num;

    }
    
    const onChangeUser = (e) => {
        setIsModi(true)
        const { name, value } = e.target;
        console.log('name', name);
        console.log('value', value);
      
        setModifyObj({
            ...modifyObj,
            [name]: value
        })
        console.log('modifyObj', modifyObj);
    }

    const uploadImage = (e) => {
        let u_login_id = '';
        if (window.sessionStorage.result) {
            let parseSe = JSON.parse(window.sessionStorage.result);
            u_login_id = parseSe.u_login_id;
        }
        const { id, files } = e.target;
        let file = files[0];
        let dir = u_login_id;
        console.log('file : ', file)
        let formData = new FormData();
        formData.append('dir', dir);
        formData.append('img', file);
        fileUpload(formData, id);
    }

    // const [modifyObj, setModifyObj] = useState('');

    const fileUpload = (formdata, id) => {
        const fetchData = async () => {
            instance.post('/file/image', formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(function (res) {
                    console.log('res : ', res);
                    let path = res.data.path;
                    path = path.slice(7, path.length);
                    let url = 'https://abys-service.co.kr:3001//' + path;
                    setInputs({
                        ...inputs,
                        si_img: JSON.stringify([url]),
                    })
                    setData({
                        ...data,
                        si_img: JSON.stringify([url])
                    })
                });
        };

        fetchData();
    }

    let updateObj = {
        obj: inputs,
        whereField: 'si_id',
        whereValue: si_id
    }

    const modify = () => {
        console.log('updateObj : ', updateObj)
        modifyuser();
        const fetchData = async () => {
            instance.post('/sigong/update', updateObj).then(function (res) {
                console.log('res : ', res)
                // setData(res.data[0]);
                alert('정상적으로 수정되었습니다.');
                modifyuser();
            });
        };
        fetchData();
    }

    const modifyuser = () => {

        console.log('수정 직 전 modifyObj : ',modifyObj)
 
        const fetchData = async () => {
            instance.post('/users/update',
            {obj:modifyObj,whereField:'u_id',whereValue:u_id})
            .then(function(res){
    
                loadUser()
                setIsModi(false)
            });
        
        };
    
        fetchData();
    }

    const loadUser = () => {

        console.log('수정 직 전 modifyObj : ',modifyObj)
        let obj = {
            u_id:u_id,  
          }
        const fetchData = async () => {
            instance.post('/users/u_id',obj).then(function(res){
               console.log('res', res);
               window.sessionStorage.setItem('result', JSON.stringify(res.data[0]));
            });
        
        };
    
        fetchData();
    }


    const imgStyle = {
        width: '100px',
        height: '100px',
    }
    const v = data;
    const pbottom = {
        paddingBottom : '90px'
    }

    
    return (
        <>
            <TopTitle title="시공점 등록" />
            <div className="container" style={pbottom}>
                <div className="mb-3">
                    <label>AS등록</label>
                    <input type="text" className="form-control" name="si_as" value={si_as} onChange={onChange} />
                </div>
                <div className="mb-3">
                    <label>지점</label>
                    <select type="text" className="form-control" name="si_area1" value={si_area1} onChange={onChange} >
                        <option value="">선택</option>
                        <option value="서울">서울</option>
                        <option value="경기">경기</option>
                        <option value="인천">인천</option>
                        <option value="강원">강원</option>
                        <option value="광주">광주</option>
                        <option value="세종">세종</option>
                        <option value="전라남도">전남</option>
                        <option value="전라북도">전북</option>
                        <option value="대구">대구</option>
                        <option value="대전">대전</option>
                        <option value="부산">부산</option>
                        <option value="경상남도">경남</option>
                        <option value="경상북도">경북</option>
                        <option value="울산">울산</option>
                        <option value="충청남도">충남</option>
                        <option value="충청북도">충북</option>
                        <option value="제주">제주</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label>지역</label>
                    <Sigungu 
                    si_area1={si_area1} 
                    si_area2={si_area2} 
                    onChange={onChange}
                    />
                </div>
                <div className="mb-3">
                    <label>지점명</label>
                    <input type="text" className="form-control" name="si_name" value={si_name} onChange={onChange} />
                </div>
                <div className="mb-3">
                    <label>연락처</label>
                    <input type="text" className="form-control" name="si_tel" value={si_tel} onChange={onChange} />
                </div>
                <div className="mb-3">
                    <label>전화번호</label>
                    <input type="text" className="form-control" name="si_tel2" value={si_tel2} onChange={onChange} />
                </div>
                <div className="mb-3">
                    <label>실내시공 가능여부</label>
                    <div className="row px-0">
                        <select className="form-control" name="si_possible" value={si_possible} onChange={onChange} disabled>
                            <option value="Y">가능</option>
                            <option value="N">불가능</option>
                            <option value="공백">공백</option>
                        </select>
                    </div>
                </div>
                <div className="mb-3">
                    <label>휴계실유무</label>
                    <input type="text" className="form-control" name="si_rest" value={si_rest} onChange={onChange} />
                </div>
                <div className="mb-3">
                    <label>차량 동시 시공 대수</label>
                    <input type="text" className="form-control" name="si_dongsi" value={si_dongsi} onChange={onChange} />
                </div>
                <div className="mb-3">
                    <label className="d-block">썸네일</label>
                    <label htmlFor="file-upload" className="btn btn-sm btn-primary text-center mpEdit-btn col-3 d-block">업로드</label>
                    <input id="file-upload" type="file" className="d-none" accept="image/png, image/jpeg, image/jpg" onChange={uploadImage} />
                    {
                        v.si_img
                            ? 
                            <>
                            {
                                JSON.parse(v.si_img).map(vv => <img src={vv} className="mt-2" style={imgStyle} />)
                            }
                            
                            </>
                            : <span>썸네일을 등록해주세요.</span>
                    }

                </div>
                <div className="mb-3">
                    <label>주소 <img className="d-none" src={serach_img} style={{width:'20px'}} onClick={() => setIsPost(!isPost)}/></label>
                    <input type="text" className="form-control" name="si_address" value={si_address} disabled/>
                </div>
                <div className="mb-3">
                    <label>사업자등록번호</label>
                    <input type="text" className="form-control" name="u_company_num" value={u_company_num} onChange={onChangeUser} />
                </div>
                <div className="mb-5">
                    <label>사업자명</label>
                    <input type="text" className="form-control" name="u_company_name" value={u_company_name} onChange={onChangeUser} />
                </div>      

                <div className="row">
                    <div className="col"><span className="btn btn-primary mb-5 mr-5 col-12" onClick={() => history.goBack()}>뒤로가기</span></div>
                    <div className="col"><span className="btn btn-primary mb-5 col-12" onClick={modify}>수정</span></div>
                    
                </div>
            </div>
            <Bottom_menu />
            {
                isPost &&
                <Postcode
                inputs={inputs}
                setInputs={setInputs}
                isPost={isPost}
                setIsPost={setIsPost}
                />
            }
            
        </>
    );
}

export default S_storeSetting;